import React from 'react'
import { Place} from '../../types'
import { useTranslation } from 'react-i18next'
import { FaStar } from 'react-icons/fa6'
import { CiLocationOn } from 'react-icons/ci'
import { Link } from 'react-router-dom'
import LocationButton from '../ui/LocationButton'

const TripPlace = ({ place }: { place: Place }) => {
    const { t } = useTranslation()
    return (
        <section>
            <h4 className=' text-lg font-semibold mb-2'>{t("place-title")}</h4>
            <div className=' grid  xs:grid-cols-1 md:grid-cols-2 items-center gap-5'>
                <Link to={`/place/${place.id}`} className='  grid md:grid-cols-3 xs:grid-cols-1 flex-1 gap-5 bg-white rounded-2xl border border-grayColor  overflow-hidden'>
                    <div className='col-span-1  ' >
                        <img src={place.images[0].url} className=' object-cover h-full ' alt="place" loading='lazy' />
                    </div>
                    <div className=' space-y-2 p-3 xs:col-span-1 md:col-span-2'>
                        {place.subCategory&&<p className=' bg-primary px-2 py-1 rounded-lg w-fit text-sm text-white '>{place.subCategory.title}</p>}
                        <div className=' flex justify-between '>
                            <p className=' text-xl font-semibold'>{place.title}</p>
                            <p className=' flex items-center gap-1'>
                                {place.rate != null ? (place.rate % 1 === 0 ? place.rate : place.rate.toFixed(1)) : '--'}{' '}
                                <FaStar className="inline text-yellow-400" />
                            </p>
                        </div>
                        <p className=' text-textSecond line-clamp-2'>{place.details}</p>
                        <div className="flex items-center    gap-1">
                            <CiLocationOn className="text-lg text-secondry" />
                            <p className='text-nowrap'>{place.location}</p>
                        </div>
                    </div>
                </Link>
                <LocationButton link={`/place/${place?.id}/map-view`}/>
            </div>
        </section>
    )
}

export default TripPlace